import { Injectable } from '@angular/core';
import {
    DwContextDefinition,
    DwCustomContextBase,
    DwCustomContextDefinition
} from '@devwareapps/devware-cap';
import {
    AppMetaDataItemNames,
    FlightSchoolApplicantEntity
} from '../../../meta-data/app-meta-data.service';

export const FlightSchoolApplicantCurrentContext = 'flight-school-applicant-current-context';

@DwCustomContextDefinition({
    keyName: FlightSchoolApplicantCurrentContext,
    display: 'Flight School Applicant Current Context',
    isGlobal: false,
    parentItem: AppMetaDataItemNames.FlightSchoolApplicant
})
@Injectable()
export class FlightSchoolApplicantCurrentContextService extends DwCustomContextBase {
    setupContextDefinition(contextDef: DwContextDefinition): void {
        contextDef.getCustomContextFunction = resolvedContext =>
            resolvedContext.data as FlightSchoolApplicantEntity;
        contextDef.item = AppMetaDataItemNames.FlightSchoolApplicant;
        contextDef.useItemMetaData = true;
    }
}
